import { GetterTree } from 'vuex';
import { RootState } from '../types';
import { FeedbackState } from './types';

import { Item, Comments } from '@/models';

export const getters: GetterTree<FeedbackState, RootState> = {
}
